import { render, staticRenderFns } from "./app-update.vue?vue&type=template&id=c48df1ae"
import script from "./app-update.vue?vue&type=script&lang=ts"
export * from "./app-update.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports